module.exports = __webpack_public_path__ + "img/heart-edit.ab645d51.svg";